<template>
  <div class="">
    <div class="is-flex is-align-center">
      <eden-page-header :title="'Reviews'" />
      <el-dropdown class="dropdown-with-buttons ml-2" @command="setPeriod" :style="{ marginBottom: '50px' }">
        <el-button size="mini" type="primary" plain>
          {{ periods[period] }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(value, key, i) in periods" :key="i" :command="key"
            :class="{ selected: period === key }">{{ value }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
      v-if="period === 'custom'"
      title="Reviews For"
      :visible.sync="showCustomDate"
      @close="closeEvent"
      width="30%"
    >
      <el-form :model="form" label-position="top">
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item label="Range" prop="dateRange">
              <el-date-picker
                v-model="form.dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="From"
                end-placeholder="To"
                format="dd MMM, yyyy"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="closeEvent">Cancel</el-button>
        <el-button
          type="primary"
         @click="handleGetCustomDate"
          :disabled="form.dateRange.length == 0"
          >Get</el-button
        >
      </span>
    </el-dialog>
    </div>
    <el-tabs v-model="tab" @tab-click="updateRoute">
      <el-tab-pane v-for="eachTab in tabs" :label="eachTab.label" :name="eachTab.name" :key="eachTab.name">
        <component :is="'MarketplaceFeedback'" :tags="eachTab" :period="period" :custom-date.sync="customDate" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MarketplaceFeedback from "@/components/MarketplaceFeedback/FeedbackTable";
import * as actions from "@/store/action-types";
export default {
  name: "Reviews",
  components: {
    MarketplaceFeedback,
  },

  data() {
    return {
      newTag: null,
      tab: "all",
      period: "thisweek",
      periods: {
        today: "Today",
        thisweek: "This week",
        thismonth: "This month",
        custom: "Custom",
      },
      form: {
        dateRange: [],
      },
      showCustomDate: false,
      customDate: [],
    };
  },

  computed: {
    TagsTable() {
      return MarketplaceFeedback;
    },
    tabs() {
      let businessTypes = this.$store.getters.business_types.map((type) => ({
        name: type.name.toLowerCase(),
        label: type.name,
        id: type.id,
      }));

      // Add an 'all' tab to the beginning of the array
      businessTypes.unshift({ name: "all", label: "All", id: "" });

      return businessTypes;
    },
    businessTypes() {
      return this.$store.getters.business_types;
    },
  },

  watch: {
    period() {
      if (this.period == "custom") {
        this.showCustomDate = true;
      }
    },
  },

  created() {
    let { tab } = this.$route.query;
    this.tab = tab ? tab : "all";
    if (!tab) {
      this.$router.push({
        name: "marketplace-feedback.index",
        query: { tab: "all" },
      });
    }
    this.getBusinessType();
  },

  methods: {
    closeEvent() {
      this.showCustomDate = false;
    },
    setPeriod(period) {
      this.period = period;
    },
    handleGetCustomDate() {
      this.customDate = this.form.dateRange;
      this.showCustomDate = false;
      this.period = 'custom';
    },
    getBusinessType() {
      this.loading = true;
      this.$store.dispatch(actions.GET_BUSINESS_TYPE).then(() => {
        // this.businessType = this.businessTypes;
        this.loading = false;
      });
    },
    updateRoute(tab) {
      const currentTab = this.$route.query.tab;

      if (currentTab === this.tab) {
        return false;
      }
      this.$router.push({
        name: "marketplace-feedback.index",
        query: { tab: tab.name },
      });
    },
  },
};
</script>